import { AddressTypeEnum } from "@lib/enum"
import { ignoreBodyByModel } from "@models/global"

export class CustomerPotentialModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerPotentialModel(), obj)

    newObj.currentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.CURRENT
    )
    newObj.permanentAddress = obj.customerAddresses?.find(
      (item) => item.addressType === AddressTypeEnum.PERMANENT
    )
    newObj.hasCurrentAddress = !!newObj.currentAddress
    newObj.tags = obj.tags?.map((tag) => ({
      label: tag,
      value: tag,
    }))
    newObj.areas = obj.areas?.map((area) => ({
      label: area?.provinceName,
      value: area?.id,
    }))
    newObj.projects = obj.projects?.map((project) => ({
      label: project?.projectName,
      value: project?.id,
    }))
    newObj.propertyTypes = obj.propertyTypes?.map((item) => ({
      label: item?.name,
      value: item?.id,
    }))
    newObj.primaryPhone =
      obj.customerPhoneNumbers?.find((phone) => phone.isPrimary)?.phoneNumber ??
      undefined
    newObj.primaryEmail =
      obj.customerEmailAddresses?.find((email) => email.isPrimary)
        ?.emailAddress ?? undefined
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CustomerPotentialUpdateModel {
  id: any
  constructor() {
    this.id = undefined
  }

  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerPotentialUpdateModel(), obj)
    newObj.tags = obj.tags?.map((tag) => tag.value)
    newObj.areaIds = obj.areas?.map((area) => area?.value)
    newObj.projectIds = obj.projects?.map((project) => project?.value)
    newObj.propertyTypeIds = obj.propertyTypes?.map((item) => item?.value)

    newObj.customerAddresses = [
      obj.currentAddress
        ? { addressType: AddressTypeEnum.CURRENT, ...obj.currentAddress }
        : undefined,
      obj.permanentAddress
        ? { addressType: AddressTypeEnum.PERMANENT, ...obj.permanentAddress }
        : undefined,
    ].filter((item) => item !== undefined)
    return newObj
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}

export class CustomerBookingUpdateModel {
  id?: number
  sourceId?: any
  type?: any
  firstName?: any
  lastName?: any
  fullName?: any
  shortName?: any
  birthDate?: any
  gender?: any
  identifierCardNumber?: any
  idIssuedDate?: any
  idIssuedPlace?: any
  nationalityId?: any
  represenFullName?: any
  represenIdentifierCardNumber?: any
  represenPhoneNumber?: any
  represenEmail?: any
  represenDescription?: any
  isRepresen?: any
  isCompany?: any
  companyName?: any
  companyTaxCode?: any
  companyAddress?: any
  customerAddresses?: any[]
  customerPhoneNumbers?: any[]
  customerEmailAddresses?: any[]
  //
  repCountryId?: any
  repProvinceId?: any
  repDistrictId?: any
  repIdIssuedDate?: any
  repIdIssuedPlace?: any
  repCompanyTaxCode?: any
  repBirthDate?: any
  repNationalityId?: any
  customerType?: any
  represenEmails?: any
  represenPhoneNumbers?: any
  represenIdIssuedDate?: any
  represenIdIssuedPlace?: any
  represenNationalityId?: any
  legalRepresentative?: any
  position?: any
  legalRepresentativeIdentityCardNumber?: any
  legalRepresentativeIdIssueDate?: any
  legalRepresentativeIdIssuePlace?: any

  beneficiary?: any
  bankNumber?: any
  bankName?: any
  bankBranch?: any
  description?: any

  constructor() {}
  public static assign(obj) {
    if (!obj) return undefined

    const newObj = Object.assign(new CustomerBookingUpdateModel(), obj)
    newObj.customerAddresses = [
      obj.currentAddress
        ? { addressType: AddressTypeEnum.CURRENT, ...obj.currentAddress }
        : undefined,
      obj.permanentAddress
        ? { addressType: AddressTypeEnum.PERMANENT, ...obj.permanentAddress }
        : undefined,
    ].filter((item) => item !== undefined)
    return ignoreBodyByModel(newObj, CustomerBookingUpdateModel)
  }

  public static assigns(objs) {
    const results: any[] = []
    objs?.forEach((item) => results.push(this.assign(item)))
    return results
  }
}
